// extracted by mini-css-extract-plugin
module.exports = {"team":"team-result_team__39S54","row":"team-result_row__2_Rbo"};